import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function loadScoringHistory(documentId, siteId) {
  return get(`${url}/leasingdocument/${documentId}/${siteId}/historyscoring`);
}

export function loadScoringHistorySession(documentId, siteId, sessionID) {
  return get(`${url}/leasingdocument/${documentId}/${siteId}/${sessionID}/historyscoringsession`);
}
